import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '@/i18n/locales/en/common.json';
import viCommon from '@/i18n/locales/vi/common.json';

const STORAGE_KEY = 'lang';

/**
 * Persisted language → 'en'. English-first for now; Vietnamese labels get
 * translated later (missing `vi` keys fall back to `en` via i18next fallbackLng).
 */
function resolveInitialLang(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
  } catch {
    // localStorage unavailable — fall through.
  }
  return 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    vi: { common: viCommon },
  },
  lng: resolveInitialLang(),
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

/** Switch language and persist the choice. */
export function setLanguage(lang: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // Best-effort persistence.
  }
  void i18n.changeLanguage(lang);
}

export default i18n;
